module.exports = __webpack_public_path__ + "static/img/black-bgis.50f28cd6.jpg";